import React from 'react';
import "./css/tailwind.css";
import './css/App.css';

import Logo from './components/logo';
import Menu from './components/menu';
import Skill from './components/skill';

function App() {
  return (
      <div className="container">
        <div className="flex flex-wrap font-raleway">
          <div className="shadow-xl container w-full xl:w-1/3 lg:w-1/3 sm:w-1/3 md:w-1/3 bg-yellow-500 m-auto text-center text-black p-6 h-screen">
            <Logo />
            <Menu />
          </div>
          <div className="w-full sm:w-2/3 lg:w-2/3 xl:w-2/3 md:w-2/3 p-6">
            <div>
              <p className="text-lg text-center">
                <div className="pb-6">
                  <h3 className="text-lg mb-2 border-b-2 border-gray-100 pb-2">About</h3>
                  Hi, I'm Kemal.
                  I study computer engineering at <a href="#" className="font-bold border-b-2 text-gray-800 border-gray-400 hover:bg-gray-400 p-1">Erciyes University</a>,
                  I live in <a href="#" className="font-bold border-b-2 text-gray-800 border-gray-400 hover:bg-gray-400 p-1">Kayseri</a> and <a href="#" className="hover:bg-gray-400 p-1 font-bold border-b-2 text-gray-800 border-gray-400">Izmir</a>.
                </div>
                <div className="mt-6 pt-6 pb-4">
                  <h3 className="text-lg mb-2 border-b-2 border-gray-100 pb-2">Skills</h3>
                  <Skill name="php" color="green" />
                  <Skill name="ruby on rails" color="orange" />
                  <Skill name="python" color="orange" />
                  <Skill name="c / c++" color="yellow" />
                  <Skill name="laravel" color="green" />
                  <Skill name="lumen" color="green" />
                  <Skill name="react native" color="yellow" />
                  <Skill name="mongodb" color="green" />
                  <Skill name="mysql" color="green" />
                  <Skill name="sqlite" color="green" />
                  <Skill name="postgresql" color="green" />
                  <Skill name="css" color="green" />
                  <Skill name="javascript" color="orange" />
                  <Skill name="vue" color="yellow" />
                  <Skill name="react" color="yellow" />
                  <Skill name="bootstrap" color="green" />
                  <Skill name="tailwindcss" color="green" />
                  <Skill name="jquery" color="green" />
                  <Skill name="gulp" color="red" />
                  <br />
                  <div className="mt-3">
                    <span className="mr-3 text-sm"><span className="mr-1 w-3 h-3 bg-green-400 rounded px-1"></span> advanced </span>
                    <span className="mr-3 text-sm"><span className="mr-1 w-3 h-3 bg-orange-400 rounded px-1"></span> intermediate </span>
                    <span className="mr-3 text-sm"><span className="mr-1 w-3 h-3 bg-yellow-400 rounded px-1"></span> pre-intermediate </span>
                    <span className=" text-sm"><span className="mr-1 w-3 h-3 bg-red-400 rounded px-1"></span> beginner </span>
                  </div>
                </div>

                <div className="mt-6 pt-6">
                  <h3 className="text-lg mb-2 border-b-2 border-gray-100 pb-2">Contact</h3>
                  <div className="flex">
                    <div className="w-1/2">
                    </div>
                  </div>
                </div>
              </p>
            </div>
          </div>
        </div>
      </div>
  );
}

export default App;
